import React, { forwardRef } from "react";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";
import PropTypes from "prop-types";
import { dMMMyyyy } from "../../utils/constants/appConstants";

const CustomInput = forwardRef(({ value, onClick, placeholderText }, ref) => (
  <input
    ref={ref}
    value={value || ""}
    onClick={onClick}
    readOnly
    autoComplete="off"
    name="disable-autofill-date"
    placeholder={placeholderText}
    className={Style.datepicercustom}
  />
));
CustomInput.propTypes = {
  value: PropTypes.any,
  onClick: PropTypes.any,
  placeholderText: PropTypes.string
};

CustomInput.displayName = "CustomInput";

const UsableDatePicker = ({
  value,
  onChange,
  minDate,
  maxDate,
  placeholderText
}) => {
  return (
    <Datepicker
      selected={value}
      onChange={onChange}
      dateFormat={dMMMyyyy}
      minDate={minDate}
      maxDate={maxDate}
      customInput={<CustomInput placeholderText={placeholderText} />}
      autoComplete="off"
    />
  );
};

UsableDatePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  placeholderText: PropTypes.string
};

export default UsableDatePicker;
